/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../index";
type GeneratedSubscription<InputType, OutputType> = string & {
  __generatedSubscriptionInput: InputType;
  __generatedSubscriptionOutput: OutputType;
};

export const connectEWBCI = /* GraphQL */ `subscription ConnectEWBCI($input: ConnectEWBCIInput!) {
  connectEWBCI(input: $input) {
    userId
    sessionId
    requestId
    requestedAt
    responsedAt
    serialId
    deviceId
    api
    body
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.ConnectEWBCISubscriptionVariables,
  APITypes.ConnectEWBCISubscription
>;
